import React from 'react';

interface SpinnerProps {
	height?: string;
	margin?: string;
}

export class Spinner extends React.Component<SpinnerProps, {}>
{
	public static defaultProps: Partial<SpinnerProps> = {
		height: '40px',
		margin: '50px auto'
	};

	public render() {
		const style = {
			height: this.props.height!,
			margin: this.props.margin!
		};

		return <div className='spinner' style={style}><div /><div /><div /><div /><div /></div>;
	}
}

export default Spinner;